import { useMutation } from "@tanstack/react-query";

import { requestResetPasswordToken } from "#modules/auth/infra/requestResetPasswordToken.api";

export const useRequestResetPasswordToken = ({ onSuccess }: { onSuccess: () => void }) => {
  const { mutate, ...rest } = useMutation({
    mutationFn: requestResetPasswordToken,
    onSuccess: () => {
      onSuccess();
    },
  });

  return { resetPassword: mutate, ...rest };
};
